import AmigoGaming from '../components/Icons/IconProvider/AmigoGaming';
import AsiaGaming from '../components/Icons/IconProvider/AsiaGaming';
import BeterLive from '../components/Icons/IconProvider/BeterLive';
import BetGames from '../components/Icons/IconProvider/BetGames';
import Bolebit from '../components/Icons/IconProvider/Bolebit';
import EvolutionGaming from '../components/Icons/IconProvider/EvolutionGaming';
import FaChai from '../components/Icons/IconProvider/FaChai';
import GoatSports from '../components/Icons/IconProvider/GoatSports';
import Habanero from '../components/Icons/IconProvider/Habanero';
import HoGaming from '../components/Icons/IconProvider/HoGaming';
import ImagineLive from '../components/Icons/IconProvider/ImagineLive';
import JadeSports from '../components/Icons/IconProvider/JadeSports';
import Jili from '../components/Icons/IconProvider/Jili';
import Joker from '../components/Icons/IconProvider/Joker';
import KAGaming from '../components/Icons/IconProvider/KAGaming';
import MGLive from '../components/Icons/IconProvider/MGLive';
import Microgaming from '../components/Icons/IconProvider/Microgaming';
import PragmaticPlay from '../components/Icons/IconProvider/PragmaticPlay';
import PragmaticPlayCasino from '../components/Icons/IconProvider/PragmaticPlayCasino';
import PrettyGaming from '../components/Icons/IconProvider/PrettyGaming';
import RedTiger from '../components/Icons/IconProvider/RedTiger';
import SimplePlay from '../components/Icons/IconProvider/SimplePlay';
import SportsPlus from '../components/Icons/IconProvider/SportsPlus';
import TFGaming from '../components/Icons/IconProvider/TFGaming';

export default [
  {
    id: 1,
    image: <EvolutionGaming />,
    name: 'Evolution Gaming',
    slug: 'casino'
  },
  {
    id: 2,
    image: <PragmaticPlayCasino />,
    name: 'Pragmatic Play Casino',
    slug: 'casino'
  },
  {
    id: 3,
    image: <Microgaming />,
    name: 'Microgaming',
    slug: 'casino'
  },
  {
    id: 4,
    image: <MGLive />,
    name: 'MG Live',
    slug: 'casino'
  },
  {
    id: 5,
    image: <ImagineLive />,
    name: 'Imagine Live',
    slug: 'casino'
  },
  {
    id: 6,
    image: <AsiaGaming />,
    name: 'Asia Gaming',
    slug: 'casino'
  },
  {
    id: 7,
    image: <HoGaming />,
    name: 'Ho Gaming',
    slug: 'casino'
  },
  {
    id: 8,
    image: <BeterLive />,
    name: 'Beter Live',
    slug: 'slots'
  },
  {
    id: 9,
    image: <BetGames />,
    name: 'Bet Games',
    slug: 'slots'
  },
  {
    id: 10,
    image: <PrettyGaming />,
    name: 'Pretty Gaming',
    slug: 'casino'
  },
  {
    id: 11,
    image: <Bolebit />,
    name: 'Bolebit',
    slug: 'slots'
  },
  {
    id: 12,
    image: <RedTiger />,
    name: 'Red Tiger',
    slug: 'slots'
  },
  {
    id: 13,
    image: <AmigoGaming />,
    name: 'Amigo Gaming',
    slug: 'slots'
  },
  {
    id: 14,
    image: <Joker />,
    name: 'Joker',
    slug: 'slots'
  },
  {
    id: 15,
    image: <Jili />,
    name: 'Jili',
    slug: 'slots'
  },
  {
    id: 16,
    image: <SimplePlay />,
    name: 'Simple Play',
    slug: 'slots'
  },
  {
    id: 17,
    image: <FaChai />,
    name: 'Fa Chai',
    slug: 'slots'
  },
  {
    id: 18,
    image: <Habanero />,
    name: 'Habanero',
    slug: 'slots'
  },
  {
    id: 19,
    image: <KAGaming />,
    name: 'KA Gaming',
    slug: 'slots'
  },
  {
    id: 20,
    image: <PragmaticPlay />,
    name: 'Pragmatic Play',
    slug: 'slots'
  },
  {
    id: 21,
    image: <JadeSports />,
    name: 'Jade Sports',
    slug: 'sports'
  },
  {
    id: 22,
    image: <TFGaming />,
    name: 'TF Gaming',
    slug: 'sports'
  },
  {
    id: 23,
    image: <SportsPlus />,
    name: 'Sports Plus',
    slug: 'sports'
  },
  {
    id: 24,
    image: <GoatSports />,
    name: 'GOAT Sports',
    slug: 'sports'
  },
];